// import React, { useEffect, useState } from 'react';
// import locationIcon from "../../assest/icons/locationIcon.png";
// import magelocationIcon from "../../assest/icons/magelocationIcon.png";
// import uploadIcon from "../../assest/icons/uploadIcon.png";
// import searchIcon from "../../assest/icons/searchIcon.png";
// import { apiGET, apiPOST } from '../../utilities/apiHelpers';
// import { API_URL } from '../../config';
// import { toast } from 'react-toastify';
// import Loader from '../Loader/Loader';
// import './ChildNavbar.css';  // Import custom CSS for animations
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// const ChildNavbar = () => {
//     const navigate = useNavigate()
//     const [allProducts, setAllProducts] = useState([]);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [filteredResults, setFilteredResults] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [locationData, setLocationData] = useState(null);
//     const [locationLoading, setLocationLoading] = useState(false);
//     const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
//     const { userData } = useSelector((state) => state.user);
//     const location = useLocation();


//     const handleInputChange = (e) => {
//     setGlobalSearchLoading(true);
//     const value = e.target.value;
//     setSearchTerm(value);

//     // 1. Guard clause: Check if value exists and allProducts is actually an array
//     if (value && Array.isArray(allProducts)) {
//         const results = allProducts.filter(result =>
//             result?.name?.toLowerCase().includes(value.toLowerCase())
//         );
//         setFilteredResults(results);
//         setShowDropdown(true);
//     } else {
//         setShowDropdown(false);
//     }

//     setGlobalSearchLoading(false);
// };

//     const handleResultClick = (item) => {
//         setSearchTerm(item?.name);
//         setShowDropdown(false);
//         navigate(`/product/${item?._id}`)
//     };

//     const handleLocationSet = async () => {
//         try {
//             setLocationLoading(true);
//             const response = await apiGET(`${API_URL}/v1/users/getUserIpDetails`);
//             if (response?.data?.status) {
//                 setLocationData(response?.data?.data);
//                 setLocationLoading(false);
//                 toast.success("Location set successfully");
//             } else {
//                 setLocationLoading(false);
//                 toast.error("Something went wrong");
//             }
//         } catch (error) {
//             console.error("Error getting location details:", error);
//             setLocationLoading(false);
//         }
//     };

//     const getAllProduct = async () => {
//         try {
//             const payload = { "keyword": "" };
//             const response = await apiPOST(`${API_URL}/v1/product/globalSearchProducts`, payload);
//             if (response?.data?.status) {
//                 setAllProducts(response?.data?.data);
//             } else {
//                 console.error("Something went wrong");
//             }
//         } catch (error) {
//             console.error("Something went wrong", error);
//         }
//     };
// //  const getAllProduct = async () => {
// //     try {
// //         const payload = { "keyword": "" };
// //         const response = await apiPOST(`${API_URL}/v1/product/globalSearchProducts`, payload);

// //         // Check if status is true AND data is actually an array
// //         if (response?.data?.status && Array.isArray(response?.data?.data)) {
// //             setAllProducts(response.data.data);
// //         } else {
// //             // Fallback to empty array if data is missing or wrong format
// //             setAllProducts([]); 
// //             console.error("Data received is not an array:", response?.data);
// //         }
// //     } catch (error) {
// //         setAllProducts([]); // Ensure it remains an array on error
// //         console.error("Something went wrong", error);
// //     }
// // };
//     useEffect(() => {
//         setSearchTerm('');
//         setShowDropdown(false);
//     }, [location]);

//     useEffect(() => {
//         getAllProduct();
//     }, []);

//     return (
//         <div className='bg-[#F1F9FF]'>
//             <nav className="container mx-auto p-4">
//                 <div className="lg:flex lg:items-center lg:justify-between">
//                     <div className="lg:flex lg:items-center">
//                         <div className="flex items-center bg-[#CCECEE] rounded-full lg:rounded-l-full h-10 px-3 text-blue-700">
//                             <img src={locationIcon} alt="Location Icon" />
//                             <div className='ml-2 whitespace-nowrap'>
//                                 {locationData ? `${locationData.city} ${locationData.postalCode}` : "Delhi 110010"}
//                             </div>
//                             {
//                                 locationLoading ? (
//                                     <Loader width="w-4" height="h-4" padding="px-8" />
//                                 ) : (
//                                     <img
//                                         className='ml-10 mr-8 cursor-pointer transition duration-300 transform hover:scale-110'
//                                         onClick={handleLocationSet}
//                                         src={magelocationIcon}
//                                         alt="Magelocation Icon"
//                                     />
//                                 )
//                             }
//                         </div>
//                         <div className="flex w-full lg:w-[630px] items-center relative lg:ml-[-35px] lg:my-0 my-3">
//                             <input
//                                 type="text"
//                                 value={searchTerm}
//                                 onChange={handleInputChange}
//                                 placeholder="Search Kidney Medicinesssssssssssss"
//                                 className="w-full h-10 px-3 border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring focus:border-blue-300 transition duration-300"
//                             />
//                             <div className="absolute right-2 p-2 rounded-md">
//                                 {globalSearchLoading ? (
//                                     <Loader width="w-6" height="h-6" />
//                                 ) : (
//                                     <img src={searchIcon} alt="Search Icon" />
//                                 )}
//                             </div>
//                             {showDropdown && (
//                                 <div className="absolute top-full left-0 w-full bg-white border border-gray-300 rounded-md shadow-lg mt-1 z-10 dropdown-animation max-h-[320px] overflow-y-auto scrollbar-custom scroll-smooth">
//                                     {filteredResults.length > 0 ? (
//                                         filteredResults.map((item, index) => (
//                                             <div
//                                                 key={index}
//                                                 className="px-3 py-2 hover:bg-gray-200 cursor-pointer"
//                                                 onClick={() => handleResultClick(item)}
//                                             >
//                                                 {item?.name}
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div className="flex items-center justify-center py-4 text-gray-500">
//                                             Not found
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                     <button onClick={() => userData ? navigate('/upload-prescription') : toast.info("Please login to proceed")} className="bg-[#14967F] w-full lg:w-52 h-10 text-white text-center flex justify-center items-center space-x-2 px-3 py-2 rounded-full text-sm font-medium transition duration-300 transform hover:scale-105">
//                         <img src={uploadIcon} alt="Upload Icon" />
//                         <div className='text-center' >Upload Prescription</div>
//                     </button>
//                 </div>
//             </nav>
//         </div>
//     );
// };

// export default ChildNavbar; 

import React, { useEffect, useState } from 'react';
// import locationIcon from "../../assest/icons/locationIcon.png";
// import magelocationIcon from "../../assest/icons/magelocationIcon.png";
import uploadIcon from "../../assest/icons/uploadIcon.png";
import searchIcon from "../../assest/icons/searchIcon.png";
import { apiPOST } from '../../utilities/apiHelpers';
import { API_URL } from '../../config';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import './ChildNavbar.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ChildNavbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { userData } = useSelector((state) => state.user);

    // Search States
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredResults, setFilteredResults] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [globalSearchLoading, setGlobalSearchLoading] = useState(false);

    // Location States
    // const [locationData, setLocationData] = useState(null);
    // const [locationLoading, setLocationLoading] = useState(false);

    /**
     * API Search Logic
     * Matches the structure: response -> data -> data -> product
     */
    const performGlobalSearch = async (query) => {
        if (!query.trim()) {
            setFilteredResults([]);
            setShowDropdown(false);
            return;
        }

        setGlobalSearchLoading(true);
        try {
            const payload = { "keyword": query };
            const response = await apiPOST(`${API_URL}/v1/product/globalSearchProducts`, payload);

            // FIX: Accessing the 'product' array inside the nested 'data' object
            const productArray = response?.data?.data?.product;

            if (response?.data?.status && Array.isArray(productArray)) {
                setFilteredResults(productArray);
                setShowDropdown(true);
            } else {
                setFilteredResults([]);
                setShowDropdown(true);
            }
        } catch (error) {
            console.error("Global search API error:", error);
            setFilteredResults([]);
        } finally {
            setGlobalSearchLoading(false);
        }
    };

    /**
     * Debounce Hook
     * Limits API calls to once every 500ms while typing
     */
    useEffect(() => {
        const timer = setTimeout(() => {
            if (searchTerm.trim()) {
                performGlobalSearch(searchTerm);
            } else {
                setFilteredResults([]);
                setShowDropdown(false);
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [searchTerm]);

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleResultClick = (item) => {
        setSearchTerm(item?.name || "");
        setShowDropdown(false);
        navigate(`/product/${item?._id}`);
    };

    // const handleLocationSet = async () => {
    //     try {
    //         setLocationLoading(true);
    //         const response = await apiGET(`${API_URL}/v1/users/getUserIpDetails`);
    //         if (response?.data?.status) {
    //             setLocationData(response?.data?.data);
    //             toast.success("Location set successfully");
    //         }
    //     } catch (error) {
    //         console.error("Location error:", error);
    //     } finally {
    //         setLocationLoading(false);
    //     }
    // };

    useEffect(() => {
        setSearchTerm('');
        setShowDropdown(false);
    }, [location]);

    return (
        <div className='bg-[#F1F9FF]'>
            <nav className="container mx-auto p-4">
                <div className="lg:flex lg:items-center lg:justify-between">
                    <div className="lg:flex lg:items-center">
                        {/* Location Section */}
                        {/* <div className="flex items-center bg-[#CCECEE] rounded-full lg:rounded-l-full h-10 px-3 text-blue-700">
                            <img src={locationIcon} alt="Location" />
                            <div className='ml-2 whitespace-nowrap text-sm'>
                                {locationData ? `${locationData.city} ${locationData.postalCode}` : "Delhi 110010"}
                            </div>
                            {locationLoading ? (
                                <Loader width="w-4" height="h-4" padding="px-8" />
                            ) : (
                                <img
                                    className='ml-10 mr-8 cursor-pointer transition transform hover:scale-110'
                                    onClick={handleLocationSet}
                                    src={magelocationIcon}
                                    alt="Set Location"
                                />
                            )}
                        </div> */}

                        {/* Search Input */}
                        <div className="flex w-full lg:w-[630px] items-center relative  lg:my-0 my-3">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleInputChange}
                                placeholder="Search Kidney Medicines"
                                className="w-full h-10 px-4 border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
                            />

                            <div className="absolute right-3">
                                {globalSearchLoading ? (
                                    <Loader width="w-5" height="h-5" />
                                ) : (
                                    <img src={searchIcon} alt="Search" className="w-5 h-5" />
                                )}
                            </div>

                            {/* Results Dropdown */}
                            {showDropdown && (
                                <div className="absolute top-full left-0 w-full bg-white border border-gray-200 rounded-lg shadow-xl mt-2 z-50 max-h-[300px] overflow-y-auto">
                                    {filteredResults.length > 0 ? (
                                        filteredResults.map((item, index) => (
                                            <div
                                                key={item?._id || index}
                                                className="px-4 py-3 hover:bg-gray-100 cursor-pointer border-b last:border-none text-black font-medium"
                                                onClick={() => handleResultClick(item)}
                                            >
                                                {item?.name}
                                            </div>
                                        ))
                                    ) : (
                                        !globalSearchLoading && (
                                            <div className="px-4 py-6 text-center text-gray-500">
                                                No medicines found for "{searchTerm}"
                                            </div>
                                        )
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Upload Button */}
                    <button
                        onClick={() => userData ? navigate('/upload-prescription') : toast.info("Please login to proceed")}
                        className="bg-[#14967F] w-full lg:w-56 h-10 text-white flex justify-center items-center space-x-2 px-4 rounded-full text-sm font-semibold transition hover:bg-[#117a68]"
                    >
                        <img src={uploadIcon} alt="Upload" className="w-4 h-4" />
                        <span>Upload Prescription</span>
                    </button>
                </div>
            </nav>
        </div>
    );
};

export default ChildNavbar;